<main>
	<app-banner></app-banner>
	<app-about></app-about>
	<app-jobs></app-jobs>
	<app-projects></app-projects>
	<app-more-projects></app-more-projects>
	<app-testimonial></app-testimonial>
	<app-contact></app-contact>
</main>
